import React, { FC } from 'react';
import styled from 'styled-components';

import CrossIcon from '../../assets/images/icons/cross.svg';
import { colorScheme } from '../../theme';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClick: (e: any) => void;
  disabled?: boolean;
  isEnabled?: boolean;
}

const Close = styled.img`
  margin-left: 4px;
`;

const Button = styled.button`
  display: inline-block;
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
  background: ${colorScheme.buttons.secondary.background};
  text-align: center;
  border-radius: 4px;
  padding: 6px 8px;
  color: ${colorScheme.buttons.secondary.text};
  border: none;
  margin-right: 8px;
  margin-bottom: 4px;
  transition: 150ms linear all;

  &:hover {
    background: ${colorScheme.buttons.secondary.hover};
    border-color: ${colorScheme.buttons.secondary.hover};
  }

  &:focus {
    background: #f6f8fe;
    border-color: #f6f8fe;
  }
`;

export const ToggleButton: FC<Props> = (props) => {
  const { children, isEnabled, ...rest } = props;
  return (
    <Button type="button" {...rest} className={`toggle-button ${isEnabled ? 'selected' : ''}`}>
      <span>{children}</span>
      <Close alt={`Remove ${children} filter`} src={CrossIcon} />
    </Button>
  );
};
